/* Persistent application-update prompt: users save work before consenting to reload this tab. */
import Button from '../primitives/Button';
import { foundationColorTokens, foundationSemantic } from '../../foundation';
import { useAppUpdate } from '../../hooks/useAppUpdate';

export default function BuildUpdatePrompt() {
  const { available, refreshing, error, refresh } = useAppUpdate();
  if (!available) return null;

  return (
    <section
      aria-label="Application update"
      className={`fixed bottom-4 left-4 right-4 z-[100] mx-auto flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-lg p-3 shadow-lg ${foundationSemantic.surface.default}`}
    >
      <div className="min-w-0 flex-1" role="status">
        <p className={`text-sm font-medium ${foundationColorTokens.text.primary}`}>A new version is available.</p>
        <p className={`text-xs ${foundationColorTokens.text.secondary}`}>Save your work before refreshing.</p>
        {error && <p className={foundationSemantic.field.error}>{error}</p>}
      </div>
      <Button size="sm" onClick={refresh} loading={refreshing}>
        {refreshing ? 'Refreshing…' : 'Refresh'}
      </Button>
    </section>
  );
}
